import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from './Container';
export function Footer() {
  return <footer className="bg-brand-black text-brand-white pt-[80px] pb-[30px]" data-id="element-39" data-mp="3ggaohovss12a">
      <Container data-id="element-40" data-mp="32oe09vx92bb6">
        <div className="grid grid-cols-[1.5fr_1fr_1fr_1fr] max-[800px]:grid-cols-2 gap-[40px] pb-[60px] border-b border-white/20" data-id="element-41" data-mp="32ovz90bar3ms">
          <div data-id="element-42" data-mp="36nd4feb5q41k">
            <div className="text-[clamp(2rem,3.2vw,3.2rem)] font-black leading-[0.95] tracking-[-0.025em]" data-id="element-43" data-mp="36n3grxdl48z1">
              The Abie Agency.
              <br data-id="element-44" data-mp="37o6cv1anxdd" />
              For builders.
            </div>
          </div>

          <div data-id="element-45" data-mp="3levg4zwzhcf4">
            <h4 className="font-mono text-[12px] tracking-[0.18em] uppercase opacity-60 mb-[18px]" data-id="element-46" data-mp="3ldalzbekzvhs">
              Pages
            </h4>
            <div className="flex flex-col" data-id="element-47" data-mp="3qblyxv06am48">
              <Link to="/#work" className="py-[4px] text-[15px] hover:opacity-70 transition-opacity" data-id="element-48" data-mp="29ynldknsn5e0">
                Work
              </Link>
              <Link to="/#services" className="py-[4px] text-[15px] hover:opacity-70 transition-opacity" data-id="element-49" data-mp="3l9abhd1s8u1s">
                Services
              </Link>
              <Link to="/about" className="py-[4px] text-[15px] hover:opacity-70 transition-opacity" data-id="element-50" data-mp="3v7ggw4mssibe">
                About
              </Link>
              <Link to="/#careers" className="py-[4px] text-[15px] hover:opacity-70 transition-opacity" data-id="element-51" data-mp="830gdarw9qws">
                Careers
              </Link>
              <Link to="/contact" className="py-[4px] text-[15px] hover:opacity-70 transition-opacity" data-id="element-52" data-mp="hstsccvy881k">
                Contact
              </Link>
            </div>
          </div>

          <div data-id="element-53" data-mp="qsqfub6lr0v1">
            <h4 className="font-mono text-[12px] tracking-[0.18em] uppercase opacity-60 mb-[18px]" data-id="element-54" data-mp="qub9zzp08hsd">
              Direct lines
            </h4>
            <div className="flex flex-col" data-id="element-55" data-mp="tv4lvxtlew2w">
              <a href="mailto:hello@theabieagency.com" className="py-[4px] text-[15px] hover:opacity-70 transition-opacity" data-id="element-56" data-mp="tw5wy2alzikm">
                New business
              </a>
              <a href="mailto:press@theabieagency.com" className="py-[4px] text-[15px] hover:opacity-70 transition-opacity" data-id="element-57" data-mp="13rpu0s0wsnay">
                Press
              </a>
              <a href="mailto:careers@theabieagency.com" className="py-[4px] text-[15px] hover:opacity-70 transition-opacity" data-id="element-58" data-mp="1clcgtsn52g80">
                Careers
              </a>
            </div>
          </div>

          <div data-id="element-59" data-mp="1rjemc8dqdbrw">
            <h4 className="font-mono text-[12px] tracking-[0.18em] uppercase opacity-60 mb-[18px]" data-id="element-60" data-mp="1rhtvasqmkays">
              Social
            </h4>
            <div className="flex flex-col" data-id="element-61" data-mp="3od85zdkl26mi">
              <a href="#" className="py-[4px] text-[15px] hover:opacity-70 transition-opacity" data-id="element-62" data-mp="3t9ge470d4zk6">
                Instagram
              </a>
              <a href="#" className="py-[4px] text-[15px] hover:opacity-70 transition-opacity" data-id="element-63" data-mp="25nvhspq1pa4c">
                LinkedIn
              </a>
              <a href="#" className="py-[4px] text-[15px] hover:opacity-70 transition-opacity" data-id="element-64" data-mp="1wnpaxmour8e5">
                TikTok
              </a>
              <a href="#" className="py-[4px] text-[15px] hover:opacity-70 transition-opacity" data-id="element-65" data-mp="2tbn6kssrvfmi">
                YouTube
              </a>
            </div>
          </div>
        </div>

        <div className="flex justify-between items-center pt-[28px] flex-wrap gap-[16px] text-[12px] opacity-60" data-id="element-66" data-mp="2feq6e0qrklsy">
          <span data-id="element-67" data-mp="18z5zwzef4hid">© 2026 The Abie Agency. All Rights Reserved.</span>
          <span data-id="element-68" data-mp="13z1klcp8xstq">theabieagency.com</span>
        </div>
      </Container>
    </footer>;
}